import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import type { GatepassFlowData } from "./ClaimGatepass";
import { canUserReject } from "./utils";

interface RejectGatepassProps {
  gatepassFlowData?: GatepassFlowData;
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "gatepass";

const RejectGatepass: React.FC<RejectGatepassProps> = ({ gatepassFlowData, openDrawer }) => {
  if (!gatepassFlowData?.task) {
    return null;
  }

  const isActionAvailable = Boolean(
    canUserReject(
      gatepassFlowData.task.status,
      gatepassFlowData.task.claimOwnerName,
      gatepassFlowData.status,
      gatepassFlowData.task.role,
    ),
  );

  const handleRejectClick = () => {
    openDrawer("rejectDrawer");
  };

  return (
    <RejectButton
      langBase={LANG_BASE}
      permission="canApproveGatepass"
      isActionAvailable={isActionAvailable}
      onReject={handleRejectClick}
    />
  );
};

export default RejectGatepass;
